// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3LeE0","footer":"ChangeClinic_footer__3TMsz"};